import { Controller } from 'stimulus';
import gsap from 'gsap';

class ImageBlockController extends Controller {
  connect() {
    const fullWidth = this.element.offsetWidth;
    const fullHeight = this.element.offsetHeight;
    const imageWidth = this.imageTarget.offsetWidth;
    const imageHeight = this.imageTarget.offsetHeight;

    this.timeline = gsap.timeline({
      paused: true,
    });

    this.isFullWidth = fullWidth === imageWidth;

    const scale = this.isFullWidth
      ? 1.1
      : fullHeight / imageHeight;

    this.timeline
      .from(this.imageTarget, { scale: 1 })
      .to(this.imageTarget, { scale });
  }

  scrollHandler(scrollElementObject) {
    const { progress } = scrollElementObject;

    const virtualProgress = this.isFullWidth
      ? progress
      : progress * 2;

    this.timeline.progress(virtualProgress).pause();
  }
}

ImageBlockController.targets = [
  'image',
];

export default ImageBlockController;
